import styled from 'styled-components';

export const ExpandedRow = styled.tr`
  display: ${({ show }) => (show ? 'table-row !important' : 'none')};
  padding-left: 12px;
`;
